import { useEffect, useState } from "react";
import { Cookie } from "lucide-react";
import { PRIVACY_URL } from "@/constants/links";
import {
  getAnalyticsConsent,
  loadGoogleAnalytics,
  setAnalyticsConsent,
} from "@/lib/googleAnalytics";

export function CookieConsent() {
  const [isOpen, setIsOpen] = useState(() => getAnalyticsConsent() === null);

  useEffect(() => {
    if (getAnalyticsConsent() === "granted") void loadGoogleAnalytics();
  }, []);

  const choose = (value) => {
    setAnalyticsConsent(value);
    setIsOpen(false);
    if (value === "granted") void loadGoogleAnalytics();
  };

  if (!isOpen) {
    return (
      <button
        type="button"
        className="gf-cookie-open fixed bottom-4 left-4 z-[80] inline-flex min-h-11 items-center gap-2 rounded-full border border-slate-200 bg-white px-4 text-sm font-bold text-slate-700 shadow-lg transition hover:border-violet-300 hover:text-violet-700 focus-visible:outline focus-visible:outline-3 focus-visible:outline-offset-2 focus-visible:outline-violet-600"
        onClick={() => setIsOpen(true)}
        aria-label="Apri le preferenze cookie"
      >
        <Cookie aria-hidden="true" size={18} />
        Cookie
      </button>
    );
  }

  return (
    <aside
      aria-label="Preferenze cookie e analytics"
      aria-live="polite"
      className="gf-cookie-banner fixed inset-x-0 bottom-0 z-[80] p-4 [padding-bottom:max(1rem,env(safe-area-inset-bottom))]"
    >
      <div className="gf-cookie-content mx-auto flex w-full max-w-5xl flex-col gap-4 rounded-2xl border border-slate-200 bg-white p-5 text-slate-700 shadow-2xl sm:flex-row sm:items-center">
        <div className="flex min-w-0 flex-1 items-start gap-3">
          <span className="grid h-10 w-10 shrink-0 place-items-center rounded-full bg-violet-100 text-violet-700" aria-hidden="true">
            <Cookie size={20} />
          </span>
          <div>
            <strong className="block text-sm text-slate-900">Cookie e statistiche del sito</strong>
            <p className="mt-1 text-sm leading-6">
              I cookie tecnici sono sempre attivi. Con il tuo consenso usiamo
              Google Analytics per capire quali pagine funzionano meglio; non
              usiamo cookie pubblicitari. Puoi cambiare scelta in ogni momento. {" "}
              <a className="font-bold text-violet-700 underline underline-offset-2" href={PRIVACY_URL}>
                Informativa privacy
              </a>
            </p>
          </div>
        </div>
        <div className="gf-cookie-controls flex flex-col gap-2 sm:flex-row">
          <button
            type="button"
            className="gf-cookie-necessary min-h-11 rounded-full border border-slate-300 bg-white px-5 text-sm font-bold text-slate-700 hover:bg-slate-50"
            onClick={() => choose("denied")}
          >
            Solo necessari
          </button>
          <button
            type="button"
            className="gf-cookie-accept min-h-11 rounded-full bg-violet-700 px-5 text-sm font-bold text-white hover:bg-violet-800"
            onClick={() => choose("granted")}
          >
            Accetta analytics
          </button>
        </div>
      </div>
    </aside>
  );
}
